import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import Newsletter from "./Newsletter";

export default function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="bg-cp-encre text-cp-ivoire mt-24 relative cp-grain cp-above" data-testid="site-footer">
            <div className="max-w-[1600px] mx-auto px-6 md:px-12 pt-20 md:pt-32 pb-12">

                {/* Colophon top: running marquee */}
                <div className="cp-marquee text-cp-ivoire/90 border-y border-cp-ivoire/20 py-8 mb-16">
                    <div className="cp-marquee__track cp-serif text-5xl md:text-6xl">
                        {Array.from({ length: 2 }).flatMap((_, i) => [
                            <span key={`a${i}`}>Blangy</span>,
                            <span key={`b${i}`} className="cp-display-italic text-cp-sable">· Eu ·</span>,
                            <span key={`c${i}`}>Le Tréport</span>,
                            <span key={`d${i}`} className="cp-display-italic text-cp-sable">· Mers-les-Bains ·</span>,
                            <span key={`e${i}`}>Forêt royale</span>,
                            <span key={`f${i}`} className="cp-display-italic text-cp-sable">· Vallée de la Bresle ·</span>,
                        ])}
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-20 border-b border-cp-ivoire/15">
                    <div className="md:col-span-6">
                        <p className="cp-tiny text-cp-sable mb-8">{t("footer.tagline")}</p>
                        <h3 className="cp-serif text-5xl md:text-6xl lg:text-7xl leading-[0.95] text-cp-ivoire mb-8">
                            <Trans
                                i18nKey="footer.newsletterTitle"
                                components={{ i: <em className="cp-display-italic text-cp-sable" /> }}
                            />
                        </h3>
                        <div className="max-w-md">
                            <Newsletter variant="dark" source="footer" />
                        </div>
                    </div>

                    <div className="md:col-span-3 md:col-start-8">
                        <p className="cp-tiny text-cp-sable mb-5">{t("footer.explore")}</p>
                        <ul className="flex flex-col gap-2.5 cp-serif text-2xl text-cp-ivoire/80">
                            <li><Link to="/destinations" className="hover:text-cp-sable transition-colors">{t("nav.destinations")}</Link></li>
                            <li><Link to="/adresses" className="hover:text-cp-sable transition-colors">{t("nav.adresses")}</Link></li>
                            <li><Link to="/evenements" className="hover:text-cp-sable transition-colors">{t("nav.agenda")}</Link></li>
                            <li><Link to="/balades" className="hover:text-cp-sable transition-colors">{t("nav.balades")}</Link></li>
                            <li><Link to="/magazine" className="hover:text-cp-sable transition-colors">{t("nav.magazine")}</Link></li>
                            <li><Link to="/carte" className="hover:text-cp-sable transition-colors">{t("nav.carte")}</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <p className="cp-tiny text-cp-sable mb-5">{t("footer.editorial")}</p>
                        <ul className="flex flex-col gap-2.5 text-cp-ivoire/70 text-sm font-light">
                            <li><Link to="/contact" className="hover:text-cp-sable" data-testid="footer-contact-link">{t("footer.writeUs")}</Link></li>
                            <li><Link to="/faq" className="hover:text-cp-sable" data-testid="footer-faq-link">FAQ</Link></li>
                            <li><Link to="/soumettre-evenement" className="hover:text-cp-sable" data-testid="footer-submit-event-link">Proposer un événement</Link></li>
                            <li><Link to="/week-end" className="hover:text-cp-sable">{t("footer.weekendBespoke")}</Link></li>
                            <li><a href="mailto:hello@coteperdue.com" className="hover:text-cp-sable">hello@coteperdue.com</a></li>
                        </ul>
                        <p className="cp-script text-2xl text-cp-sable mt-8">{t("footer.writeReally")}</p>
                    </div>
                </div>

                <div className="pt-10 flex flex-col md:flex-row justify-between items-start md:items-end gap-4">
                    <p className="cp-tiny text-cp-ivoire/50">© {new Date().getFullYear()} Côte Perdue. {t("footer.rights")}</p>
                    <p className="cp-serif text-cp-ivoire/40 text-lg italic max-w-xs">
                        {t("footer.creed")}
                    </p>
                </div>
            </div>
        </footer>
    );
}
